// Constants
export const CHUNK_SIZE = 8 * 1024 * 1024; // 8 MiB - Discord safe limit
export const MAX_CONCURRENT_UPLOADS = 4;
export const MAX_CONCURRENT_DOWNLOADS = 6;
export const CACHE_TTL = 120; // seconds
export const DEFAULT_EXPIRATION_DAYS = 30;
